import React from "react";

const Purpose = () => (
  <section className="my-8 text-center">
    <h2 className="text-4xl font-bold mb-4">Purpose</h2>
    <p className="text-lg text-justify mb-4">
        This assessment aims to collect data on learners' readability levels, information processing abilities, and working memory capacity. The information gathered will be used solely to train a model supporting an adaptive E-learning framework, which will leverage Genetic algorithms to tailor educational resources to meet each learner's unique needs, enhancing engagement and learning effectiveness. Your responses are confidential, will not be shared, and will not be used for any other purposes.
    </p>
  </section>
);

export default Purpose;
